import { AkukoAPIService } from './serviceClass';
import { IDENTITY_API } from '../configs/env';
import { 
  SpaceUserGroup, 
  SpaceUserGroupMember, 
  CreateGroupRequest, 
  AssignMembersRequest,
  RenameGroupRequest,
  ApiResponse 
} from '../types/spaceUserGroups';

export class SpaceUserGroupService extends AkukoAPIService {
  constructor(url?: string) {
    super(IDENTITY_API, url ? `space/${url}` : 'space');
  }

  async createGroup(request: CreateGroupRequest): Promise<SpaceUserGroup> {
    return this.create(request) as Promise<SpaceUserGroup>;
  }

  async assignMembers(groupId: string, request: AssignMembersRequest): Promise<SpaceUserGroup> {
    return this.update(request, null, 'PUT') as Promise<SpaceUserGroup>;
  }

  async listGroups(): Promise<SpaceUserGroup[]> {
    return this.list(null, 'GET') as Promise<SpaceUserGroup[]>;
  }

  async getGroupMembers(groupId: string): Promise<SpaceUserGroupMember[]> {
    return this.read(groupId, null, 'GET') as Promise<SpaceUserGroupMember[]>;
  }

  async renameGroup(groupId: string, request: RenameGroupRequest): Promise<SpaceUserGroup> {
    return this.update(request, null, 'PUT') as Promise<SpaceUserGroup>;
  }

  async removeMember(): Promise<ApiResponse> {
    return this.delete(null, 'DELETE') as Promise<ApiResponse>;
  }

  async deleteGroup(): Promise<ApiResponse> {
    return this.delete(null, 'DELETE') as Promise<ApiResponse>;
  }
} 